import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../ProgressBar/index.js';
import calcProgress from './calcProgress.js';
import s from './composeLabels.js';
import TimeLeft from './time/TimeLeft.js';
import TotalTime from './time/TotalTime.js';

const {
  shape,
  string,
  number,
  bool
} = PropTypes;
function ContentHeaderCompletedText({
  updatedAt,
  finishedAt,
  labels
}) {
  return /*#__PURE__*/React.createElement("span", null, s(labels.completed, {
    date: finishedAt
  }), updatedAt && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "slds-m-horizontal_x-small"
  }, "\u2022"), s(labels.updated, {
    date: updatedAt
  })));
}
ContentHeaderCompletedText.displayName = "ContentHeaderCompletedText";
function ContentProgress({
  content,
  user,
  expanded,
  labels
}) {
  if (user && content.type === "superbadge" && !user.unlocked && !user.finishedAt) {
    return /*#__PURE__*/React.createElement("span", null, content.estimatedTime);
  }
  if (user && user.finishedAt) {
    if (expanded) {
      return /*#__PURE__*/React.createElement(ContentHeaderCompletedText, {
        updatedAt: content.updatedAt,
        finishedAt: user.finishedAt,
        labels: labels
      });
    }
    return /*#__PURE__*/React.createElement("span", null, s(labels.completed, {
      date: user.finishedAt
    }));
  }
  if (user) {
    const progress = calcProgress(user, content);
    if (content.type === "trail" && progress === 100) {
      return /*#__PURE__*/React.createElement("span", null, s(labels.completed, {
        date: ""
      }));
    }
    const showTimeLeft = user.estimatedTime && progress > 0 && progress < 100;
    const showTotalTime = content.estimatedTime && !showTimeLeft || content.type === "customstep";
    const showProgressBar = content.type !== "customstep";
    return /*#__PURE__*/React.createElement("div", {
      className: "slds-grid slds-grid_vertical-align-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slds-m-right_x-small slds-shrink-none",
      "data-test": "progress-estimated-time-and-percentage",
      "data-progress-value": progress
    }, expanded && showTimeLeft && /*#__PURE__*/React.createElement(TimeLeft, {
      estimatedTime: user.estimatedTime
    }), (expanded || content.type === "customstep") && showTotalTime && /*#__PURE__*/React.createElement(TotalTime, {
      totalTime: content.estimatedTime,
      separator: content.type !== "customstep"
    }), showProgressBar && `${progress}%`), showProgressBar && /*#__PURE__*/React.createElement(ProgressBar, {
      value: progress,
      style: {
        minWidth: "6rem"
      },
      labels: labels
    }));
  }
  return /*#__PURE__*/React.createElement("span", null, content.estimatedTime);
}
ContentProgress.displayName = "ContentProgress";
ContentHeaderCompletedText.defaultProps = {
  updatedAt: null,
  finishedAt: ""
};
ContentHeaderCompletedText.propTypes = {
  updatedAt: string,
  finishedAt: string,
  labels: shape({
    completed: string,
    updated: string
  }).isRequired
};
ContentProgress.propTypes = {
  labels: shape({
    completed: string,
    updated: string,
    progress: string
  }).isRequired,
  content: shape({
    updatedAt: string,
    unitCount: number,
    estimatedTime: string
  }).isRequired,
  user: shape({
    estimatedTime: string,
    finishedAt: string,
    unlocked: bool,
    completedCount: number,
    progress: number
  }),
  expanded: bool
};
ContentProgress.defaultProps = {
  user: null,
  expanded: false
};

export { ContentHeaderCompletedText, ContentProgress as default };
